import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

// Import your existing UI utilities
import CustomTabs from '../../common/custom-tabs';
import typography from '../../cssUtils/typography';
import { grayFontColor } from '../../cssUtils/constants';

// Import the two child components
import RateCardTab from './RateCardTab';
import RCSRateCard from './RCSRateCard'; // replaces RCSMessageRates (old RCSRateCard model), kept on disk

const MessageRatesDashboard = () => {
  // 🟢 1. Fetch permissions to determine channel access
  const permissionsFromStorage = JSON.parse(localStorage.getItem("permissions") || "[]");
  const hasRcsBotCreate = permissionsFromStorage.includes("rcs_bot_create.view");
  // conversations.view is granted only by WhatsApp addons, so it marks the WA channel
  const hasWa = permissionsFromStorage.includes("conversations.view");

  // 🟢 2. SMART DEFAULT: Default to RCS (1) if RCS user, otherwise WhatsApp (0)
  const initialTab = hasWa ? 0 : 1;
  const [activeTab, setActiveTab] = useState(initialTab);

  console.log("Rendering MessageRatesDashboard with activeTab:", activeTab);

  // 🟢 3. Mutually Exclusive Tabs Layout
  const allChannelTabs = [
    { label: "WhatsApp", value: 0, show: hasWa },
    { label: "RCS", value: 1, show: hasRcsBotCreate }
  ];

  // Filter out the hidden tabs
  const channelTabs = allChannelTabs.filter(tab => tab.show !== false);

  return (
    <Box sx={{ backgroundColor: '#f5f7fa', minHeight: '100vh', py: 3, px: 3 }}>
      <Box>
        {/* ── UNIFIED PAGE HEADER ── */}
        <Box sx={{ p: 3, mb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
            <Box>
              <Typography sx={{ ...typography.h1, mb: 0.5, fontWeight: 500 }}>
                Message Rates & Pricing
              </Typography>
              <Typography sx={{ ...typography.h2, color: grayFontColor }}>
                View multi-channel rate cards by country
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              {/* Channel Switcher Tabs */}
              <CustomTabs
                tabs={channelTabs}
                value={activeTab}
                onChange={(e, v) => setActiveTab(v)}
                activeBgColor='#1976D2'
                inactiveBgColor='#e1e9f0'
                backgroundColor='#e1e9f0'
              />
            </Box>
          </Box>
        </Box>

        {/* ── TAB CONTENT RENDERING ── */}
        <Box sx={{ px: 3 }}>
          {activeTab === 0 && (
            // WhatsApp Rate Card Component
            <RateCardTab />
          )}

          {activeTab === 1 && (
            // RCS Rate Card Component
            <RCSRateCard />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MessageRatesDashboard;